import { Action } from '@ngrx/store';

export const UPDATE_CURRENT_USER = '[USER] Update current user';
export const UPDATE_CURRENT_USER_LOADED = '[USER] Update current user loaded';
export const CLEAR_USER_LOAD_STATUS = '[USER] Clear User Load Status';
export const SET_USER_INFO = '[USER] Set user information';
export const SET_USER_AGE = '[USER] Set user age';
export const SET_USER_SITE_AND_LINE_INFO = '[USER] Set user site id-name and line id-name';
export const SET_USER_SITE_ID_AND_LINE_ID = '[USER] Set user site id and line id';
export const SET_USER_TIMEZONE = '[USER] Set user site timezone';
export const SET_USER_LANGUAGE = '[USER] Set user site language';
export const SET_USER_DATE_FORMAT = '[USER] Set user site date format';
export const SET_USER_DECIMAL_SEPARATOR = '[USER] Set user site decimal separator';
export const SET_USER_THOUSAND_SEPARATOR = '[USER] Set user site thousand separator';
export const SET_CLIENT_CODE = '[USER] Set Client Code';
export const SET_AUTH_TOKEN = '[USER] Set Auth Token';
export const SET_DATA_INTERVAL = '[USER] Set Data Interval';
export const SET_CLIENT_OEE_FORMULA = '[USER] Set Client Oee Formula';
export const SET_FLEXIBLE_OBSERVATION_ACTIVE = '[USER] Set Flexible Observation Active';
export const SET_CHECK_IN_ACTIVE = '[USER] Set Check In Active';
export const SET_LABOR_AND_ASSET_LOG_ACTIVE = '[USER] Set Labor And Asset Log Active';
export const SET_SCHEDULER_ACCESS = '[USER] Set Scheduler Access';
export const CURRENT_USER_LOADING = '[USER] Current user is loading';
export const CURRENT_USER_LOADED = '[USER] Current user is loaded';
export const FETCH_ERROR = '[USER] Fetch Error';
export const SET_ACCESS_TOKEN_LOADED = '[USER] Set Access token is loaded';
export const GET_USER_FEED_TOKEN = '[USER] Get user feed token';
export const GET_USER_FEED_TOKEN_LOADED = '[USER] Get user feed token loaded';
export const GET_NOTIFICATION_LIST = '[USER] Get notification list';
export const GET_NOTIFICATION_LIST_LOADED = '[USER] Get notification list loaded';
export const GET_NOTIFICATION_LIST_WITH_LIMIT_ZERO_LOADED = '[USER] Get notification list with limit zero loaded';
export const SET_AUTHORIZED_SITES_AND_LINES = '[USER] Set Authorized Sites And Lines';

export class UpdateCurrentUser implements Action {
  readonly type = UPDATE_CURRENT_USER;

  constructor(
    public selectedSiteId: number,
    public selectedLineId: number,
    public selectedSiteName: string,
    public selectedLineName: string,
    public expectedSpeed?: number,
    public unitId?: number,
  ) {}
}
export class UpdateCurrentUserLoaded implements Action {
  readonly type = UPDATE_CURRENT_USER_LOADED;
}

export class ClearUserLoadStatus implements Action {
  readonly type = CLEAR_USER_LOAD_STATUS;
}
export class SetUserInfo implements Action {
  readonly type = SET_USER_INFO;

  constructor(public username: string, public userId: string, public userLevelId: string, public fullName: string, public defaultSite: string) {}
}

export class SetUserAge implements Action {
  readonly type = SET_USER_AGE;

  constructor(public age: number) {}
}

export class SetUserSiteIdNameAndLineIdName implements Action {
  readonly type = SET_USER_SITE_AND_LINE_INFO;

  constructor(
    public siteId: number,
    public siteName: string,
    public lineId: number,
    public lineName: string,
    public expectedSpeed: number,
    public unitId: number,
    ) {}
}

export class SetUserSiteIdAndLineId implements Action {
  readonly type = SET_USER_SITE_ID_AND_LINE_ID;

  constructor(public siteId: number, public lineId: number) {}
}

export class SetUserTimezone implements Action {
  readonly type = SET_USER_TIMEZONE;

  constructor(public timezone: string) {}
}

export class SetUserLanguage implements Action {
  readonly type = SET_USER_LANGUAGE;

  constructor(public language: string) {}
}

export class SetUserDateFormat implements Action {
  readonly type = SET_USER_DATE_FORMAT;

  constructor(public dateFormat: string, public locale: string) {}
}

export class SetUserDecimalSeparator implements Action {
  readonly type = SET_USER_DECIMAL_SEPARATOR;

  constructor(public decimalSeparator: '.' | ',') {}
}

export class SetUserThousandSeparator implements Action {
  readonly type = SET_USER_THOUSAND_SEPARATOR;

  constructor(public thousandSeparator: string) {}
}

export class SetClientCode implements Action {
  readonly type = SET_CLIENT_CODE;

  constructor(public clientCode: string) {}
}

export class SetDataInterval implements Action {
  readonly type = SET_DATA_INTERVAL;

  constructor(public dataInterval: number) {}
}

export class SetClientOeeFormula implements Action {
  readonly type = SET_CLIENT_OEE_FORMULA;

  constructor(public oeeFormula: string) {}
}

export class CurrentUserLoading implements Action {
  readonly type = CURRENT_USER_LOADING;
}

export class CurrentUserLoaded implements Action {
  readonly type = CURRENT_USER_LOADED;
}

export class FetchError implements Action {
  readonly type = FETCH_ERROR;

  constructor(public payload: any[]) {}
}

export class SetFlexibleObservationActive implements Action {
  readonly type = SET_FLEXIBLE_OBSERVATION_ACTIVE;

  constructor(public isFlexibleObservationActive: boolean) {}
}

export class SetCheckInActive implements Action {
  readonly type = SET_CHECK_IN_ACTIVE;

  constructor(public isLaborTrackerActive: boolean, public isAssetTrackerActive: boolean) { }
}

export class SetLaborAndAssetLogActive implements Action {
  readonly type = SET_LABOR_AND_ASSET_LOG_ACTIVE;

  constructor(public isLaborLogsActive: boolean, public isAssetLogsActive: boolean) { }
}

export class SetSchedulerAccess implements Action {
  readonly type = SET_SCHEDULER_ACCESS;

  constructor(public hasSchedulerAccess: boolean) {}
}

export class SetAccessTokenLoaded implements Action {
  readonly type = SET_ACCESS_TOKEN_LOADED;
}

export class SetAuthorizedSitesAndLines implements Action {
  readonly type = SET_AUTHORIZED_SITES_AND_LINES;

  constructor(public authorizedSites: string, public authorizedLines: string) { }
}

export type UserActions =
  | UpdateCurrentUser
  | UpdateCurrentUserLoaded
  | ClearUserLoadStatus
  | SetUserInfo
  | SetUserAge
  | SetUserSiteIdNameAndLineIdName
  | SetUserSiteIdAndLineId
  | SetUserTimezone
  | SetUserLanguage
  | SetUserDateFormat
  | SetUserDecimalSeparator
  | SetUserThousandSeparator
  | SetClientCode
  | SetDataInterval
  | SetClientOeeFormula
  | SetFlexibleObservationActive
  | SetCheckInActive
  | SetLaborAndAssetLogActive
  | SetSchedulerAccess
  | CurrentUserLoading
  | CurrentUserLoaded
  | FetchError
  | SetAccessTokenLoaded
  | SetAuthorizedSitesAndLines;
